import { useIntl } from 'react-intl'
import { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import SearchTileRowInclusionItem from 'components/SearchKit/SearchTiles/shared/SearchTileRowInclusionItem'
import { buildHybridSearchFilterInclusions } from 'lib/offer/inclusionUtils'
import { inclusionFilterTypeMessageByValue } from 'constants/inclusions'

const Inclusions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${rem(4)} ${rem(12)};
`

interface Props {
  inclusions: ReadonlyArray<App.OfferInclusion>
  isCard: boolean
  onShowMore: () => void
}

export default function SearchMapInclusions({ inclusions, isCard, onShowMore }: Props) {
  const intl = useIntl()
  const summaries = useMemo(() => buildHybridSearchFilterInclusions(
    [...inclusions],
    Infinity,
    filterType => intl.formatMessage(inclusionFilterTypeMessageByValue[filterType]),
  ), [inclusions, intl])
  if (!isCard) return <BodyText variant="medium" colour="light-foreground-alt" lineClamp={2}>{intl.formatList(inclusions.map(item => item.description))}</BodyText>
  const hiddenCount = Math.max(0, inclusions.length - Math.min(summaries.length, 5))
  return <Inclusions>
    {summaries.slice(0, 5).map(inclusion => <SearchTileRowInclusionItem key={inclusion.id ?? inclusion.description} inclusion={inclusion} variant="medium" colour="light-foreground-alt" lineClamp={2} />)}
    {hiddenCount > 0 && <TextLink size="medium" onClick={onShowMore}>{intl.formatMessage({
      id: 'GUifRw7XSlhL30gwZoh0',
      defaultMessage: '+{count, number} more',
    }, { count: hiddenCount })}
    </TextLink>}
  </Inclusions>
}
